import { CheckIcon, UncheckIcon } from "assests/images";

export const CheckBoxIcon = () => {
  return <img src={UncheckIcon} alt="checkbox" />;
};

export const CheckedBoxIcon = () => {
  return <img src={CheckIcon} alt="checkbox" />;
};
